module.exports = __webpack_public_path__ + "static/app_development-e33c32fdf9e269a8986c291230f3febd.svg";